export default {
    customers: [],
    activeCustomer: {},
    manageCustomerDialog: false,
    manageDeleteCustomerDialog: false
}
